import React from "react";
export const review = () => {
  return (
    <div className="opinion-wrap">
      <h1>对复查意见不服怎么办？</h1>
      <div className="text-cont">
        &nbsp; &nbsp; &nbsp; &nbsp;
        &nbsp;根据《信访工作条例》第三十六条规定，信访人对复查意见不服的，可以自收到书面答复之日起30日内向复查单位、部门的上一级单位、部门请求复核。收到复核请求的单位、部门应当自收到复核请求之日起30日内提出复核意见。
      </div>
      <br />
    </div>
  );
};
